
import Vue from 'vue'
import DataPrivacy from '~/components/sections/DataPrivacy.vue'
import { generateHead } from '~/core/config/head.config'
export default Vue.extend({
  name: 'LandingPage',
  components: { DataPrivacy },
  layout: 'landing',
  auth: false,
  /* istanbul ignore next */
  head() {
    const head = generateHead('mhLanding')
    head.bodyAttrs.class = 'public-area-theme mh'
    head.link.push({
      hid: 'canonical',
      rel: 'canonical',
      href: 'https://www.hausheld.ch/de/datenschutz/',
      hreflang: 'de',
    })
    return { ...head }
  },
})
